import { darkColors, lightColors } from '../../theme/colors'

export const light = {
  background: lightColors.backgroundAlt,
}

export const dark = {
  background: darkColors.backgroundAlt,
}
